// extracted by mini-css-extract-plugin
export default {"wrapper":"ioMFV","description":"D7UZj"};